import { render, staticRenderFns } from "./ManageCourses.vue?vue&type=template&id=2a3c1874&"
import script from "./ManageCourses.vue?vue&type=script&lang=js&"
export * from "./ManageCourses.vue?vue&type=script&lang=js&"
import style0 from "./ManageCourses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports